

export const createSteppedCumulativeCost = function(xyData: {x: number, y:number}[]): {x: number, y:number}[]{

  const totalAnalysisPeriodLength = xyData.slice(-1)[0].x - xyData[0].x;
  const xAxisPadding = Math.ceil(totalAnalysisPeriodLength * 0.1)

  // Anchor to zero and show jump at first payment
  const r: {x: number, y: number}[] = [
    {x: xyData[0].x - xAxisPadding, y: 0}
  ];

  let costToDate = 0;

  xyData.forEach((d, i) => {
    // console.log("r", r);

    // Create stepped cumulative distribution
    if (r.length > 0){
      r.push({x: d.x, y: costToDate });
    }
    r.push({x: d.x, y: d.y + costToDate});

    costToDate += d.y;
    // console.log("CostToDate", costToDate)
  });


  r.push({x: r.slice(-1)[0].x + Math.ceil(totalAnalysisPeriodLength*0.1), y: r.slice(-1)[0].y});

  // console.log("Data", r);

  return r

};
